const getSelectedHotelId = state => state?.app?.active_hotel_id;

export default getSelectedHotelId;
